import img1 from "../../images/bkacktigershrimp.jpg"
import img2 from "../../images/BOMBAYDUCK.jpg"
import img3 from "../../images/catfish.jpg"
import img4 from "../../images/BLACKPOMFRET.jpg"
import img5 from "../../images/cuttlefish.jpg"
import img6 from "../../images/DOTTEDFISH.jpeg"
import img7 from "../../images/eelfish.jpg"
import img8 from "../../images/FRESHWATER SHRIMP.jpeg"
import img9 from "../../images/GREYMULLET.jpg"
import img10 from "../../images/GROUPER.jpg"
import img11 from "../../images/HILSA.jpg"
import img12 from "../../images/horse-mackerel.png"
import img13 from "../../images/indianmackerel.jpg"
import img14 from "../../images/KASKI.jpg"
import img15 from "../../images/kingfish.jpg"
import img16 from "../../images/LIZARDFISH.jpg"
import img17 from "../../images/LOBSTER.jpg"
import img18 from "../../images/NAISER.jpg"
import img19 from "../../images/octopus.jpg"
import img20 from "../../images/queenfish.jpg"
import img21 from "../../images/REDSNAPPER.jpg"
import img22 from "../../images/robbonfish.jpg"
import img23 from "../../images/ROHU.png"
import img24 from "../../images/SARDINE.jpg"
import img25 from "../../images/SCAD.jpg"
import img26 from "../../images/SHADFISH.jpeg"
import img27 from "../../images/silvercroaker.jpg"
import img28 from "../../images/solefish.jpg"
import img29 from "../../images/squid.png"
import img30 from "../../images/STRINGRAY.jpg"
import img31 from "../../images/tuna.jpg"
import img32 from "../../images/yellowcroaker.jpg"


const product_card = [
    {
        id : 1,
        product_name : "Black Tiger Shrimp",
        description : "Striped like its jungle namesake, the black tiger shrimp is available year-round and is one of Asia’s major aquaculture products",
        thumb: img1
    },
    {
        id : 2,
        product_name : "bombay duck",
        description : "The Bombay duck lives in the tropical areas of the Indo-Pacific. The fish is also known as strange fish because of its discontinuous distribution along the Indian coast.",
        thumb: img2
    },
    {
        id : 3,
        product_name : "cat fish",
        description : "Catfish, any of the fishes of the order Siluriformes. Catfishes are related to the characins, carp, and minnows (order Cypriniformes) and may be placed with them in the superorder Ostariophysi",
        thumb: img3
    },
    {
        id : 4,
        product_name : "black pomfret",
        description : "The black pomfret (Parastromateus niger) is a species of carangid native to reefs of the Indian,the Philippines, China, southern Japan and Australia.",
        thumb: img4
    },
    {
        id : 5,
        product_name : "cuttle fish",
        description : "Cuttlefish, any of several marine cephalopods of the order Sepioidea, related to the octopus and squid and characterized by a thick internal calcified shell called the cuttlebone.",
        thumb: img5
    },
    {
        id : 6,
        product_name : "dotted gizzard shad",
        description : " Its common names include dotted gizzard shad, konoshiro gizzard shad, and spotted sardine. It is native to the northwestern Pacific Ocean, where it occurs along the Asian coastline",
        thumb: img6
    },
    {
        id : 7,
        product_name : "eel fish",
        description : " Eel, any of more than 800 species of teleost fishes characterized by elongate wormlike bodies. Anguilliforms include the common freshwater eels as well as the voracious marine morays.",
        thumb: img7
    },
    {
        id : 8,
        product_name : "Fresh water shrimp",
        description : " From the basic ghost shrimp (Palaemonetes paludosus) that are typically sold as feeder shrimp, to the well-known Amano or algae-eating shrimp",
        thumb: img8
    },
    {
        id : 9,
        product_name : "grey mullet",
        description : " Slow-growing, long-lived and late-maturing, grey mullet is one of three mullet species which occur in northern European waters.",
        thumb: img9
    },
    {
        id : 10,
        product_name : "Grouper",
        description : "Groupers are fish of any of a number of genera in the subfamily Epinephelinae of the family Serranidae, in the order Perciformes.",
        thumb: img10
    },
    {
        id : 11,
        product_name : "Hilsa",
        description : "It is a very popular and sought-after food fish in the Indian Subcontinent. The most famous hilsha fish comes from Chandpur District, Bangladesh",
        thumb: img11
    },
    {
        id : 12,
        product_name : "horse mackerel",
        description : "The horse mackerel (Trachurus trachurus) is widely distributed from Africa to the Norwegian Sea. It is a pelagic fish feeding on zooplankton, fish larvae and smaller fish",
        thumb: img12
    },
    {
        id : 13,
        product_name : "dotted gizzard shad",
        description : "The Indian mackerel is a species of mackerel in the scombrid family of order Perciformes. It is commonly found in the Indian and West Pacific oceans, and their surrounding seas",
        thumb: img13
    },
    {
        id :14,
        product_name : "kaski",
        description : "It is also called Cirrhinus mrigala, Cirrhinus cirrhosus, Morakhi, Moree, White carp and Mrigal carp fish. It is native to streams and rivers of south Asia.",
        thumb: img14
    },
    {
        id : 15,
        product_name : "King fish",
        description : "Found in shallow coastal waters over sand to sandy mud bottoms; rather common in the surf zone and in estuaries; juveniles may enter tidal rivers and creeks of low salinity",
        thumb: img15
    },
    {
        id : 16,
        product_name : "Lizard fish",
        description : "Lizardfish, any of about 57 species of marine fish of the family Synodontidae, found primarily in the tropics. Lizardfish are elongated with rounded bodies and scaly heads.",
        thumb: img16
    },
    {
        id : 17,
        product_name : "lobster",
        description : "Lobster, any of numerous marine crustaceans constituting the families Homaridae (or Nephropsidae), true lobsters; Palinuridae, spiny lobsters, deep-sea lobsters.",
        thumb: img17
    },
    {
        id : 18,
        product_name : "NAISER",
        description : "Naiser fish also known as the Spotted Snapper is a local fish from the UAE. It is one of the tastiest fishes to barbecue whole for an enjoyable experience.",
        thumb: img18
    },
    {
        id : 19,
        product_name : "Octopus",
        description : "Octopus, plural octopuses or octopi, in general, any eight-armed cephalopod (octopod) mollusk of the order Octopoda.",
        thumb: img19
    },
    {
        id : 20,
        product_name : "queen fish",
        description : "Four similar species are marketed as Queenfish, they all have long bodies, looking more like mackerels than like the other members of the Trevally family.",
        thumb: img20
    },
    {
        id : 21,
        product_name : "RED snapper",
        description : "Red snapper is one of the most popular of all white fish. It is naturally found all over the world with most of the fish harvests coming from the Gulf of Mexico and Indonesia.",
        thumb: img21
    },
    {
        id : 22,
        product_name : "robbon fish",
        description : "Ribbon Fish any of the members of the bony fish family Trichuridae, order Perciformes; represented in the bay of bengal.",
        thumb: img22
    },
    {
        id : 23,
        product_name : "rohu",
        description : "The rohu, rui, or roho labeo (Labeo rohita) is a species of fish of the carp family, found in rivers in South Asia. ",
        thumb: img23
    },
    {
        id : 24,
        product_name : "SARDINE",
        description : "Sardines are small epipelagic fish that sometimes migrate along the coast in large schools.",
        thumb: img24
    },
    {
        id : 25,
        product_name : "scad",
        description : "Scad, any of several species of fishes in the family Carangidae (order Perciformes), which also includes the jacks, amberjacks, and pompanos.",
        thumb: img25
    },
    {
        id : 26,
        product_name : "shad fish",
        description : "Shad, any of several saltwater food fishes of the herring family (Clupeidae) that swim up rivers to spawn.",
        thumb: img26
    },
    {
        id : 27,
        product_name : "silver croaker",
        description : "More on Croakers and Drums. This is a very good eating fish. The flesh is off white with a good medium flavor.",
        thumb: img27
    },
    {
        id : 28,
        product_name : "sole fish",
        description : "Sole fish also known as protonibea diacanthus is flat fish that truly relishes your taste buds.",
        thumb: img28
    },
    {
        id : 29,
        product_name : "squid fish",
        description : "Squid is a good source of vitamin B12 and B6 which the body needs for neural health and blood health and vitamin B6 for heart protection from strokes.",
        thumb: img29
    },
    {
        id : 30,
        product_name : "stingray ",
        description : "Eat stingray and it is safe to consume. Caught using fishing lines or spears, they're an interesting type of seafood you can eat.",
        thumb: img30
    },
    {
        id : 31,
        product_name : "tuna",
        description : "The high levels of omega-3 fatty acids in tuna fish may help to reduce the level of omega-6 fatty acids and LDL cholesterol that can accumulate inside the arteries of the heart.",
        thumb: img31
    },
    {
        id : 32,
        product_name : "yellow croaker",
        description : " Yellowfin croakers are safe to eat. May anglers say they are tastier than white seabass and they contain less mercury.",
        thumb: img32
    },
]

export default product_card
